import React from 'react';
import ReactDOM from 'react-dom';
import { default as App } from './App';
import './index.scss';
import { QueryClientProvider } from '@tanstack/react-query';
import QueryClient from './queryClient';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import SnackBarProvider from 'components/common/SnackBars/SnackBarProvider';

// Import the full bundle instead of named exports
import * as msal from '@azure/msal-browser/dist/index.js';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig, loginRequest } from './authConfig';

// Import your Redux store + actions
import store from './store';
import { actions as staffActions } from './ducks/staff';

// Initialize MSAL instance outside of the component tree
const msalInstance = new msal.PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback(async (event) => {
  if (event.eventType === msal.EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);

    try {
      // Get Microsoft access token silently
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });

      const microsoftToken = response.accessToken;

      // Dispatch Redux login (your backend API exchange happens here)
      await store.dispatch(staffActions.login({
        staffUserName: '',
        staffFullName: '',
        msal_token: microsoftToken
      }));

      // Ensure active account is still set after backend login
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    } catch (err) {
      console.error('Error acquiring Microsoft token:', err);
    }
  }
});

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <QueryClientProvider client={QueryClient}>
      <SnackBarProvider>
        <App />
      </SnackBarProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </MsalProvider>,
  document.getElementById('root')
);
